import { pageEntry } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";

export const entrypoints = [pageEntry("contas", designCopy.lugares.contas, () => import("./view.tsx"))];
